import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs/operators';
import { SuppressionService } from '../../../core/services/suppression.service';

@Component({
  selector: 'app-suppression-dialog',
  templateUrl: './suppression-dialog.component.html',
  styleUrls: ['./suppression-dialog.component.scss']
})
export class SuppressionDialogComponent {
  isLoading = false;
  feedbackMessage = '';
  isSuccess = false;

  readonly form = this.formBuilder.group({
    email: [
      '',
      [
        Validators.required,
        Validators.email,
        Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'),
        Validators.maxLength(256)
      ]
    ]
  });

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly suppressionService: SuppressionService,
    private readonly dialogRef: MatDialogRef<SuppressionDialogComponent>
  ) { }

  removeEmail(): void {
    if (this.form.invalid || this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.feedbackMessage = '';
    this.isSuccess = false;

    const email = (this.form.controls.email.value as string)?.trim().toLowerCase() || '';

    this.suppressionService
      .removeEmail(email)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res: any) => {
          if (res.status === 'Success') {
            this.isSuccess = true;
            this.feedbackMessage = res.statusmessage || 'Email removed successfully.';
          } else {
            this.feedbackMessage = res.statusmessage || 'Unable to remove email from suppression list.';
          }
        },
        error: (error) => {
          const apiMessage = error?.error?.statusmessage;
          this.feedbackMessage = apiMessage || 'Request failed. Please try again later.';
        }
      });
  }
}
